import { useImmer } from "use-immer";
import { useContext } from "react";
import { useDebounce } from "use-debounce";
import { AppContext } from "../../../store";
import { useReferencesQuery } from "./useReferencesQueries";

export const useReferences = ({ isReferencesList, id, type }) => {

  const [references, setReferences] = useImmer({
    status: "1",
  });
   const statusList = [
      {
        id: "1",
        label: "Active",
      },
      {
        id: "0",
        label: "Inactive",
      },
    ];
  const moduleName = "references";
  const { tableData, setSorting, setPagination, setSearchState } =
    useContext(AppContext);
  const { sorting, pagination, search } = tableData["references"];
  const [debouncedText] = useDebounce(search, 1000);
  const { referencesListQuery } = useReferencesQuery({
    isReferencesList,
    id,
    type,
    status: references.status,
    pagination,
    sorting,
    debouncedText,
  });

  const onSearchChange = (value) => {
    setPagination({
      tableName: moduleName,
      callback: (prevPagination) => ({
        ...prevPagination,
        pageIndex: 1, // Reset to the first page
      }),
    });

    // Update the search term
    setSearchState({
      tableName: moduleName,
      key: "search",
      value: value,
    });
  };
  const handleFilterChange = (value) => {
    if (value?.id) {
      setReferences((draft) => {
        draft.status = value?.id === "1" ? "1" : "0";
      });
    } else {
      setReferences((draft) => {
        draft.status =null
    })}
  };
  return {
    references,
    referencesListQuery,
    sorting,
    pagination,
    search,
    onSearchChange,
    setPagination,
    moduleName,
    setSorting,
    handleFilterChange,
    statusList
  };
};
